import { render, staticRenderFns } from "./cake.vue?vue&type=template&id=77050ae7&"
import script from "./cake.vue?vue&type=script&lang=js&"
export * from "./cake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports